var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgKitimatHeroLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 130,
    height: 108,
    viewBox: "0 0 130 108",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M38.9311 119.397L51.132 140.601H26.731L38.9311 119.397ZM9.14302 116.266H33.5349L21.6116 136.989L9.14302 116.266ZM21.3351 88.8134L33.5342 110.016H9.04076L21.3351 88.8134ZM51.1693 85.6184L38.9311 106.888L26.6887 85.6102L51.1693 85.6184ZM44.3281 116.266H71.9827L73.8755 112.956L72.1944 110.016H44.3285L58.3056 85.7232L54.6728 79.3688L19.6053 79.3569L0 113.171L20.2666 146.854H54.4956L58.1994 140.375L44.3281 116.266Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M79.1733 36.6894L66.8037 58.1901L54.4238 36.6894H79.1733ZM66.7292 9.39399L78.8463 30.438H54.6721L66.7292 9.39399ZM96.6311 6.34851L84.4073 27.594L72.1314 6.27284L96.6311 6.34851ZM114.14 30.438H89.9669L102.053 9.43137L114.14 30.438ZM84.4087 40.0986L98.1766 64.0095L102.077 63.9976L103.729 61.1499L89.6452 36.6894H117.737L117.825 36.8416L121.438 30.6103L103.893 0.117149L64.9216 0.000473022L45.5585 33.7943L63.0172 64.1179L70.6027 64.0942L84.4087 40.0986Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M122.24 32.0006L130.199 45.8015L139.023 30.4638L130.273 15.374L121.439 30.6105L122.238 32.0016L122.24 32.0006Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M70.4585 64.3435L79.1019 79.374L107.034 79.394L98.1762 64.0089L70.6023 64.0937L70.4585 64.3435Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M112.579 76.5186L126.631 52.1465L117.825 36.8416L103.73 61.1498L112.579 76.5186Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M56.5145 79.3587L71.7989 79.3696L63.017 64.1176L45.9841 64.1695L54.6736 79.3687L56.5145 79.3696V79.3587Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M89.5258 110.016L75.4993 85.627L58.3652 85.6206L58.3062 85.7236L72.195 110.016H89.5258Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M82.7006 85.6288L96.7061 110.016H124.668L110.627 85.6206L82.7006 85.6288Z",
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M130.244 58.3693L116.173 82.8216L130.188 107.103L144.204 82.7113L130.244 58.3693Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKitimatHeroLogo);
export default __webpack_public_path__ + "static/media/kitimat-hero-logo.99fdd84a1d7b2ac612160501e729ff71.svg";
export { ForwardRef as ReactComponent };